export default {
  accountTypeOptions: (state) => state.accountTypeOptions,
  accountTypeRelations: (state) => state.accountTypeRelations,
  activeUser: (state) => state.activeUser,
  activeUserAcls: (state) => {
    let activeAcls = [];
    if(state.activeUser && state.activeUser.role && state.activeUser.role.subGroupAccess) {
      activeAcls =  state.activeUser.role.subGroupAccess;
    }
    // console.log('activeAcls', activeAcls);
    return activeAcls;
  },
  activeUserRole: (state) => state.activeUser.role,
  blankUser: (state) => state.blankUser, 
  cloneAcls: (state) => state.cloneAcls,
  deactivating: (state) => state.deactivating,
  defaultAccess: (state) => state.defaultAccess,
  groupToAddTo: (state) => state.groupToAddTo,
  groupToAddUsersTo: (state) => state.groupToAddUsersTo,
  groupsToAdd: (state) => state.groupsToAdd,
  historyLoading: (state) => state.historyLoading,
  loading: (state) => state.loading,
  newUserACLs: (state) => state.newUserACLs,
  pendingAttestations: (state) => {
    if(state.activeUser !== {} && state.activeUser.role && state.activeUser.role.subGroupAccessPending) {
      return state.activeUser.role.subGroupAccessPending;
    }
    return [];
  },
  perms: (state) => state.perms,
  searchGroups: (state) => state.searchGroups,
  transactionHistory: (state) => state.transactionHistory,
  userIdsToBeAdded: (state) => state.userIdsToBeAdded,
}

